import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

export const PRECARGA_INFORME_MENSUAL = `
    query precarga($filtro: InputPrecargaInformeMensual){
        getInformeMensualPrecarga(filtro: $filtro){
            avanceAcumulado
            cumplimientoMes
            textoPrograma
            pagoPrograma
            pagoAlta
            pagoDevoluciones
        }
    }`;

// Indicadores y texto sugerido del Programa Anual para el Informe Mensual de Resultados
export const getInformeMensualPrecarga = async (filtro, token) => {
    try {
        let { getInformeMensualPrecarga } = await FetchAPI.graphql({
            token,
            variables: { filtro },
            url: urlServidor,
            query: PRECARGA_INFORME_MENSUAL
        });

        return getInformeMensualPrecarga;

    } catch ({ message }) { throw new Error(message); }
}
